export const isQA =
  window.location.host.startsWith('qa-') ||
  window.location.host.startsWith('localhost');

export const isPre = window.location.host.startsWith('pre-');

export const aiAssistantPageOrigin = `https://${
  isQA ? 'qa-' : isPre ? 'pre-' : ''
}hr.globalpand.cn/ai-assistant/global-chat`;

export const loadingImage =
  'https://startrek-web-resource.oss-cn-shanghai.aliyuncs.com/imgs/loading-effect.gif';

export const loadingTextContent = '正在加载AI智能助手...';

export const defaultBackTopProps = {
  visibleHeight: 200,
  easing: 'quartOut',
  duration: 200,
};
